import type { SeriesType } from 'ag-charts-types';

/**
 * The current chart tile version. This is the single source of truth for the version
 * sent to the backend when creating or updating chart tiles.
 * Keep in sync with DEFAULT_CHART_TILE_VERSION in genai/app/agents/common/types.py.
 */
export const CHART_TILE_VERSION = '13.1.0-1';

export const FILTER_TYPE_RANGE = 'RANGE' as const;
export const FILTER_TYPE_SELECT = 'SELECT' as const;

export const HEADLESS_ACTION_BOARD_LOADING_CLASS = 'actionBoardHeadlessLoading';

export const ACTION_BOARD_FEEDBACK_OPTIONS = [
  {
    id: 'factuallyWrongData',
    labelKey: 'ACTION_BOARD.FEEDBACK.FACTUALLY_WRONG_DATA',
  },
  {
    id: 'notHelpfulInformation',
    labelKey: 'ACTION_BOARD.FEEDBACK.NOT_HELPFUL_INFORMATION',
  },
  {
    id: 'other',
    labelKey: 'ACTION_BOARD.FEEDBACK.OTHER',
  },
] as const;

const ACTION_BOARD_COMPATIBILITY_MAP_MARKER_SERIES_TYPE = 'map-marker-series';
const AG_MAP_MARKER_SERIES_TYPE: SeriesType = 'map-marker';

export const MAP_MARKER_SERIES_TYPES: ReadonlySet<string> = new Set([
  AG_MAP_MARKER_SERIES_TYPE,
  ACTION_BOARD_COMPATIBILITY_MAP_MARKER_SERIES_TYPE,
]);
